export default __webpack_public_path__ + "static/media/menu_black.77429ab4.svg";